export default "__VITE_ASSET__CObDnj9U__"